module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_3016.4b95a80e.png";